import { translator } from 'core/localization/localization';

export const i18n = translator({
	'Export': { no: 'Eksporter' },
	'Widget already exists on dashboard': { no: 'Widgeten finnes allerede på dashbordet' },
	'Widget name': { no: 'Widget navn' },
	'Data type': { no: 'Data type' },
	'Notes': { no: 'Notater' },
	'Format': { no: 'Format' },
	'Datasource': { no: 'Datakilde' },
	'Cancel': { no: 'Avbryt' },
});
